<template>
    <div class="page">
        <!-- <main>
            <list-item></list-item>
            <list-item></list-item>
            <list-item></list-item>
            <list-item></list-item>
        </main> -->


        <div class="list-none" v-if="true">
            <img src="../../../assets/list-none.png" alt="">
            <div>空荡荡的~暂无数据！</div>
        </div>
    </div>
</template>

<script>
    // import ListItem from "./ListItem";

    export default {
        name: "List",

        components: {
            // ListItem:ListItem,
        },

        created() {
            document.title = "我的预约";
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    header {
        background: $colorDefault;
        height: 44px;
        justify-content: space-between;
        align-items: center;
        display: flex;
    }

</style>
